<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline"> Christmas HUB ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Name"
                v-model.trim="model.name"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Key"
                v-model.trim="model.key"
                v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-panel title="Settings">
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model.number="model.iconBadgeExpires" label="Icon Badge Expires" hide-details/>
              </v-col>
            </v-row>
          </r-panel>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>
        <v-row dense class="mt-3">
          <v-col cols="12" md="4" sm="4">
            <r-currency-kind-dropdown :model.sync="model.currency"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3">
          <v-col cols="12" sm="6" md="6">
            <r-smart-offer-dropdown :model.sync="model.calendarUID" :clearable="true" label="Calendar Offer"/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <r-smart-offer-dropdown :model.sync="model.constructorUID" :clearable="true" label="Constructor Offer"/>
          </v-col>
        </v-row>

        <v-row dense class="mt-3">
          <v-expansion-panels>
            <mapkind-panel :items.sync="model.maps" title="Maps"/>
          </v-expansion-panels>
        </v-row>

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-reward-track-panel :model.sync="model.rewards" title="Rewards" label="Rewards" :points="true"/>
            <r-reward-track-panel :model.sync="model.trackPrize" title="Track Prize"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleChristmasHub} from "@/modules/redactor/models/smart-offer/bundle-christmas-hub/SmartOfferBundleChristmasHub";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RRewardTrackPanel from "@/modules/redactor/views/reward/r-reward-track-panel.vue";
import mapkindPanel from "@/modules/mutils/views/map-save-action/mapkind-panel.vue";
import RSmartOfferDropdown from "@/modules/redactor/views/smart-offer/r-smart-offer-dropdown.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

export default {
  name: "r-smart-offer-bundle-christmas-hub",
  components: {
    RPanel,
    RSmartOfferDropdown,
    RRewardTrackPanel,
    RCurrencyKindDropdown,
    RGuardMoneyPanel,
    RGuardPanel,
    mapkindPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleChristmasHub(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    kinds() {
      if (!this.model) {
        return [];
      } else {
        return [ProductGroupKind.SMART_OFFERS];
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleChristmasHub();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
